import { useDispatch, useSelector } from "react-redux";
import { includes } from "lodash";
import { FormGroup, Input } from "reactstrap";
import { updateProductPageState } from "../../Product/productActions";

const PrimaryCheckBox = ({ item, handleCheckChange, itemsCheckList }) => (
  <div
    className="primary-checkbox"
    onClick={(e) => {
      e.stopPropagation();
    }}
  >
    <FormGroup check>
      <Input
        id={item?._id}
        name={item?._id}
        type="checkbox"
        onChange={handleCheckChange}
        checked={includes(itemsCheckList, item?._id)}
      />{" "}
    </FormGroup>
  </div>
);

export const Header = ({ item }) => {
  const showchecks = useSelector((state) => state.productPageStates.showchecks);
  const productTrashTab = useSelector(
    (state) => state.productParams.isTrashTab
  );

  const itemsCheckList = useSelector(
    (state) => state.productPageStates.itemsCheckList
  );
  const dispatch = useDispatch();

  const checkStatus = () => {
    return item.discover_new_videos ? (
      <span className="OnStatus">On</span>
    ) : (
      <span className="OffStatus">Off</span>
    );
  };

  const handleCheckChange = (event) => {
    const { target } = event;
    let checkedList = [];
    if (itemsCheckList.includes(target.id)) {
      // Removing item
      checkedList = itemsCheckList.filter((e) => e !== target.id);
    } else {
      // add new
      checkedList = [...itemsCheckList];
      checkedList.push(target.id);
    }
    dispatch(
      updateProductPageState({
        itemsCheckList: checkedList,
      })
    );
  };

  const handleRestoreFromTrash = () => {
    dispatch(
      updateProductPageState({
        restoreFromTrashModal: true,
        itemsCheckList: [item._id],
      })
    );
  };

  return (
    <>
      <div className="LeftStatus">
        <img
          className="Image"
          src={
            require(`@src/assets/images/vyrill/products/videoSearch.png`)
              .default
          }
        />
        {checkStatus()}
      </div>
      {showchecks && (
        <div className="RightStatus">
          {" "}
          <PrimaryCheckBox
            item={item}
            handleCheckChange={handleCheckChange}
            itemsCheckList={itemsCheckList}
          />
        </div>
      )}

      {!showchecks && productTrashTab && (
        <div
          className="RestoreButton"
          role="button"
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          <span onClick={handleRestoreFromTrash}>Restore</span>
        </div>
      )}
    </>
  );
};
